import { useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/index";
import { authActions } from "_store";
import { useDispatch } from "react-redux";
import { Language } from "./language";
import useOnClickOutside from "_hooks/useOnClickOutside";
import { hasPermission, permissionConfig } from "_helpers/permissions";

export { Nav };

function Nav() {
  const adminAccess = hasPermission(permissionConfig.adminAccess);
  const [openSetting, setOpenSetting] = useState(false);
  const openSettingAction = () => {
    setSubActive(false);
    setOpenSetting(!openSetting);
  };
  const auth = useSelector((x) => x.auth.value);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [language, setLanguage] = useState(i18n.language || "en");
  const [subActive, setSubActive] = useState(false);
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
  };
  const logout = () => dispatch(authActions.logout());

  const subNavAcitve = () => {
    setSubActive(!subActive);
  };
  // only show nav when logged in
  if (!auth) return null;
  const { firstName, middleName, lastName } = auth;

  const userDropDown = useRef(null);
  useOnClickOutside(userDropDown, () => setSubActive(false));

  const navigate = useNavigate();

  return (
    <header className="module-header d-flex align-center justify-between">
      <div className="module-header-body relative d-flex align-center justify-between">
        <div className="module-logo relative d-flex align-center justify-start">
          <NavLink to="#" className="relative d-flex align-center justify-center">
            <img src="images/Logo.svg" alt="" />
          </NavLink>
        </div>

        <div className="module-menu-list">
          <ul className="relative d-flex align-center justify-center">
            {/* <li className="relative d-flex align-center">
              <NavLink to="#" className="relative d-flex">{t("common.bulletins")}</NavLink>
            </li>
            <li className="relative d-flex align-center">
              <NavLink to="#" className="relative d-flex">{t("common.help")}</NavLink>
            </li>
            <li className="relative d-flex align-center">
              <NavLink to="#" className="relative d-flex">{t("common.modules")}</NavLink>
            </li>
            <li className="relative d-flex align-center">
              <NavLink to="#" className="relative d-flex">{t("common.tasks")}</NavLink>
            </li>
            <li className="relative d-flex align-center">
              <NavLink to="#" className="relative d-flex">{t("common.dashboard")}</NavLink>
            </li> 
            <li className="relative d-flex align-center">
              <NavLink to="/document-center" className="relative d-flex"> {t("Document Center")} </NavLink>
            </li>*/}
          </ul>
        </div>
        <div className="module-user-nav relative d-flex justify-end">
          <ul className="relative d-flex align-center justify-center">
            <li>
              <NavLink to="#" onClick={subNavAcitve} className="relative d-flex">
                <img src="images/user-icon.svg" alt="" />
              </NavLink>
              {subActive && (
                <ul className="user-n-dropdown" ref={userDropDown}>
                  <li className="d-flex align-center" onClick={() => navigate('/my-account')}>
                    <span className="material-symbols-outlined">person</span>{" "}
                    {firstName}
                  </li>
                  {/* <li className="d-flex align-center" onClick={openSettingAction}>
                    <img src="images/user-setting-icon.svg" alt="" /> Setting
                  </li> */}
                  {adminAccess && <li className="d-flex align-center" onClick={() => navigate('/admin-home')}>
                    <span className="material-symbols-outlined">settings_account_box</span> Admin
                  </li>}
                  <li className="d-flex align-center" onClick={logout}>
                    <span className="material-symbols-outlined">exit_to_app</span>{" "}
                    Logout{" "}
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>
      {openSetting && (
        <Language
          language={language}
          handleLanguageChange={handleLanguageChange}
          setOpenSetting={setOpenSetting}
        />
      )}
    </header>
  );
}
